import React from 'react';
import styles from './Loader.module.css';
import logo from './logo.webp';

const Loader = () => {
    return (
        <div className={styles.LoaderWrapper} aria-live="polite" aria-busy="true">
            <div className={styles.loader}>
                {/* Logo placed outside the boxes but inside the loader */}
                <div className={styles.logo}>
                    <img src={logo} alt="Logo" />
                </div>
                
                {/* Box elements */}
                <div className={styles.box}></div>
                <div className={styles.box}></div>
                <div className={styles.box}></div>
                <div className={styles.box}></div>
                <div className={styles.box}></div>
            </div>
        </div>
    )
}

export default Loader;